import { __ } from '@wordpress/i18n';

const getBandoLabel = (status) => {
    switch (status) {
        case 'ACTIVE':
            return __('Attivo', 'htr');

        case 'SUBMIT':
            return __('Inviato', 'htr');

        case 'PUBLISH':
            return __('Pubblicato', 'htr');

        case 'APPROVED':
            return __('Approvato', 'htr');

        case 'VALID':
            return __('Valido', 'htr');

        case 'READY_TO_PUBLISH':
            return __('Pronto', 'htr');

        case 'READY':
            return __('Pronto', 'htr');

        case 'NDG':
            return __('NDG', 'htr');

        case 'APPOINTMENT':
            return __('Appuntamento', 'htr');

        case 'ADMISSIBLE':
            return __('Ammisibile', 'htr');

        case 'TECHNICAL_EVALUATION':
            return __('Valutazione tecnico-finanziaria', 'htr');

        case 'IN_PROGRESS':
            return __('In elaborazione', 'htr');

        case 'AWAITING_TECHNICAL_EVALUATION':
            return __('Post valutazione tecnico-finanziaria', 'htr');

        case 'DUE':
            return __('In scadenza', 'htr');

        case 'RESPONSE_RECEIVED':
            return __('Risposta ricevuta', 'htr');

        case 'SOCCORSO':
            return __('Integrazioni', 'htr');

        case 'DRAFT':
            return __('Bozza', 'htr');

        case 'AWAITING':
            return __('In attesa', 'htr');

        case 'AWAIT':
            return __('In attesa', 'htr');

        case 'OPEN':
            return __('Aperto', 'htr');

        case 'ASSIGNED':
            return __('Assegnata', 'htr');

        case 'EVALUATION':
            return __('Valutazione', 'htr');

        case 'EXPIRED':
            return __('Scaduto', 'htr');

        case 'CLOSE':
            return __('Chiuso', 'htr');

        case 'INACTIVE':
            return __('Sostituito', 'htr');

        case 'DOCUMENT_UPDATED':
            return __('Aggiornato', 'htr');

        case 'REJECTED':
            return __('Respinto', 'htr');

        case 'TECHNICAL_EVALUATION_REJECTED':
            return __('Respinto Tec-Fin', 'htr');

        case 'NOT_AVAILABLE':
            return __('Non caricato', 'htr');

        case 'RECEIVED':
            return __('Ricevuto', 'htr');

        case 'INTEGRATION_REQUESTED':
            return __('Integrazioni richieste', 'htr');

        case 'INTEGRATION_EXPIRED':
            return __('Integrazione scaduta', 'htr');

        default:
            return status;
    }
};

export default getBandoLabel;